export const IQ_TECHMAX_API_URL = process.env.REACT_APP_IQ_TECHMAX_API_URL;

export const APP_CONSTANT_ASSETS_URL =
  "https://assets-dev.iqtechmax.com/assets/images/";
